/**
 * What the "Routine notifications" settings say, shared by web and native so
 * the switches read the same on both. The keys are
 * `notifications.routineNotifications`, which `notifications.NOTIFY` reads to
 * decide which of the user's channels it may use.
 */

import type { UserPreferencesRequired } from "@/types/userPreferences.ts";

type RoutineNotificationPrefs = UserPreferencesRequired["notifications"]["routineNotifications"];
export type RoutineNotificationChannel = keyof RoutineNotificationPrefs;

/** The order the settings list the channels in, with what each switch says. */
export const ROUTINE_NOTIFICATION_CHANNELS: readonly {
  key: RoutineNotificationChannel;
  title: string;
  description: string;
}[] = [
  { key: "email", title: "Email", description: "Routine results and updates in your inbox." },
  { key: "push", title: "Push", description: "On your phone and in the browser." },
  { key: "sms", title: "Text", description: "A text to your verified phone number." },
  { key: "slack", title: "Slack", description: "A Slack message, when Slack is connected." },
];

/** The note under the section heading. */
export const ROUTINE_NOTIFICATIONS_DESCRIPTION =
  "Where Okthx may send your routine results and other updates. Each routine can also be configured individually.";

/** The notifications delta that switches `channel` on or off. */
export function routineNotificationDelta(
  channel: RoutineNotificationChannel,
  on: boolean,
): { routineNotifications: Partial<RoutineNotificationPrefs> } {
  return { routineNotifications: { [channel]: on } };
}
